import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=7c1428e7&scoped=true&"
import script from "./CommentList.vue?vue&type=script&lang=js&"
export * from "./CommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1428e7",
  null
  
)

export default component.exports